import React, { useState, useEffect } from 'react';
import { registeredUser, updateUser } from "../../../../services/userMangement/userManagement";
import { FaTimes } from 'react-icons/fa';
import PasswordInput from './../../../../components/password';

const CreateUserModal = ({ visible, fetchUsers, onHide, type, toast, selectedUser, setLoading, loading }) => {

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('true');
  const [initialUserData, setInitialUserData] = useState(null);


  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  useEffect(() => {
    if (type === 'edit' && selectedUser) {
      setName(selectedUser.name);
      setEmail(selectedUser.email);
      setStatus(selectedUser.is_active ? 'true' : 'false');
      setInitialUserData(selectedUser);
    } else {
      setName('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');
      setStatus('true');
      setInitialUserData(null);
    }

    setNameError('');
    setEmailError('');
    setPasswordError('');
    setConfirmPasswordError('');
  }, [type, selectedUser]);


  const validateFields = () => {
    let isValid = true;

    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    if (!name.trim()) {
      setNameError('Full Name is required');
      isValid = false;
    }

    if (!email.trim()) {
      setEmailError('Email Address is required');
      isValid = false;
    }

    if (type === 'create') {
      if (!password) {
        setPasswordError('Password is required');
        isValid = false;
      } else if (!passwordRegex.test(password)) {
        setPasswordError('Password must be at least 8 characters long, include 1 uppercase letter, 1 number, and 1 special character');
        isValid = false;
      }

      if (password !== confirmPassword) {
        setConfirmPasswordError('Passwords do not match');
        isValid = false;
      }
    }

    return isValid;
  };

  const handleSave = async () => {
    if (!validateFields()) return;
    clearErrors();
    const accessToken = JSON.parse(localStorage.getItem('access_token'));
    const payload = {};
    if (name !== initialUserData?.name) payload.name = name;
    if (email !== initialUserData?.email) payload.email = email;
    if (status !== (initialUserData?.is_active ? 'true' : 'false')) {
      payload.is_active = status === 'true';
    }

    if (type === 'edit' && Object.keys(payload).length === 0) {
      toast.current.show({ className: "bg-yellow-700 text-white", severity: 'warn', summary: 'Warning', detail: 'Please update at least one field before saving', life: 3000 });
      return;
    }

    try {
      let response;
      if (type === 'edit' && Object.keys(payload).length > 0) {
        response = await updateUser(payload, accessToken, selectedUser.id);
      } else if (type === 'create') {
        response = await registeredUser(name, email, password, accessToken);
      }
      if (response) {
        await fetchUsers();
        toast.current.show({ className: "bg-green-300 text-white", severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
        onHide();
      }
    } catch (error) {
      console.error('Error saving user:', error);
      toast.current.show({ className: "bg-yellow-700 text-white", severity: 'warn', summary: 'Warning', detail: error.message, life: 3000 });
    }
  };

  const handleChangeName = (value) => {
    setName(value);
    if (nameError) setNameError('');
  };

  const handleChangeEmail = (value) => {
    setEmail(value);
    if (emailError) setEmailError('');
  };

  const handleChangePassword = (value) => {
    setPassword(value);
    if (passwordError) setPasswordError('');
  };

  const handleChangeConfirmPassword = (value) => {
    setConfirmPassword(value);
    if (confirmPasswordError) setConfirmPasswordError('');
  };

  if (!visible) return null;

  const resetFields = () => {
    setName('');
    setEmail('');
    setPassword('');
    setConfirmPassword('');
    setStatus('true');
    setInitialUserData(null);
  };

  const clearErrors = () => {
    setNameError('');
    setEmailError('');
    setPasswordError('');
    setConfirmPasswordError('');
  };

  const handleCancel = () => {
    if (type === 'edit' && selectedUser) {
      setName(selectedUser.name);
      setEmail(selectedUser.email);
      setStatus(selectedUser.is_active ? 'true' : 'false');
    } else {
      resetFields();
    }
    clearErrors();
    onHide();
  };

  return (
    <div>
      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-[rgba(44,52,79,1)] md:w-1/3 w-1/2 shadow-lg p-6 text-[rgba(255,255,255,1)]">
          <div className="field text-2xl flex items-center justify-between">
            {type === "edit" ? "Edit User Details" : "Create New User"}
            <FaTimes onClick={handleCancel} className='cursor-pointer' />
          </div>
          <div className="mt-4 space-y-4">
            <div className="field">
              <label htmlFor="name" className="block font-medium mb-2">Full Name*</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => handleChangeName(e.target.value)}
                className="w-full border rounded-lg p-2 border-[rgb(161,147,147)] focus:ring focus:ring-blue-500 bg-[rgba(255,255,255,0.09)]"
                required
                aria-describedby="name-error"
              />
              {nameError && <span id="name-error" className="text-red-500 text-sm">{nameError}</span>}
            </div>
            <div className="field">
              <label htmlFor="email" className="block font-medium mb-2">Email Address*</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => handleChangeEmail(e.target.value)}
                className="w-full border rounded-lg p-2 border-[rgb(161,147,147)] focus:ring focus:ring-blue-500 bg-[rgba(255,255,255,0.09)]"
                required
                aria-describedby="email-error"
                disabled={type === 'edit'}
              />
              {emailError && <span id="email-error" className="text-red-500 text-sm">{emailError}</span>}
            </div>
            {type === "create" && (
              <>
                <PasswordInput
                  label="Password"
                  value={password}
                  onChange={(e) => handleChangePassword(e.target.value)}
                  required={true}
                />
                {passwordError && <span id="password-error" className="text-red-500 text-sm">{passwordError}</span>}

                <PasswordInput
                  label="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => handleChangeConfirmPassword(e.target.value)}
                  required={true}
                />
                {confirmPasswordError && <span id="confirm-password-error" className="text-red-500 text-sm">{confirmPasswordError}</span>}
              </>
            )}
            {type !== "create" &&
              <div className='flex gap-12 pt-3 '>
                <div className="flex items-center px-2 hover:border-gray-700 gap-1 bg-primary text-white border border-[rgb(161,147,147)] rounded dark:border-gray-700">
                  <label htmlFor="bordered-radio-1" className="py-1 ms-2 text-sm font-medium dark:text-gray-300">Enable</label>
                  <input
                    id="bordered-radio-1"
                    type="radio"
                    value="true"
                    name="status"
                    checked={status === 'true'}
                    onChange={() => setStatus('true')}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                  />
                </div>
                <div className="flex items-center px-2 hover:border-gray-700 border bg-primary text-white gap-1 border-[rgb(161,147,147)] rounded dark:border-gray-700">
                  <label htmlFor="bordered-radio-2" className="py-1 ms-2 text-sm font-medium dark:text-gray-300">Disable</label>
                  <input
                    id="bordered-radio-2"
                    type="radio"
                    value="false"
                    name="status"
                    checked={status === 'false'}
                    onChange={() => setStatus('false')}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                  />
                </div>
              </div>}
            <div className="mt-4 flex gap-2">
              <button
                onClick={handleSave}
                className={`bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 flex items-center justify-center ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                disabled={loading}
              >
                {loading ? 'Saving...' : 'Save'}
              </button>
              <button
                onClick={handleCancel}
                className="bg-primary border border-gray-400 text-white px-4 py-2 rounded hover:bg-gray-600"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateUserModal;
